<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>category</md-icon>
          </div>
          <h4 class="title">優惠組合</h4>
        </md-card-header>

        <md-card-content v-if="true">
          <div class="text-right">
            <md-button href="/my" class="md-primary md-dense">
              上一頁
            </md-button>
          </div>

          <div
            v-for="(item, key) in table" :key="key"
            class="md-layout-item md-medium-size-100 md-small-size-100 md-xsmall-size-100 md-size-100"
            >
            <md-card class="md-layout-example">
              <md-card-area md-inset>
                <md-card-media md-ratio="16:9">
                  <img :src=item.image>
                </md-card-media>
                <md-card-content v-show="item.buy_url">
                  <div class="text-right">
                    <md-button :href="item.buy_url" target="_blank" class="md-primary md-dense">
                      點我購買
                    </md-button>
                  </div>
                </md-card-content>
                <md-card-header>
                  <h2 class="md-title">{{ item.name }}</h2>
                  <div class="md-subhead">
                    <md-icon>celebration</md-icon>
                    <span> 建議售價 : {{ item.price }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon>shopping_cart</md-icon>
                    <span> 組合數量 : {{ item.item_amount }}</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon>notifications</md-icon>
                    <span> 領取期限 : 購買後{{ item.expire_days }}天領用完畢</span>
                  </div>
                  <div class="md-subhead">
                    <md-icon>room</md-icon>
                    <span> 購買門市 : 所有門市皆有販售</span>
                  </div>

                </md-card-header>
                <md-card-content v-show="item.show_product">
                  <h5 v-if="item.products.length > 0">組合可選商品</h5>
                  <template v-for="product in item.products">
                    <img style="width: 25%; padding: 5px" :src="product.image"  :key="product.id">
                    <!-- {{ product.name }} -->
                  </template>
                </md-card-content>
              </md-card-area>
            </md-card>
          </div>
        </md-card-content>

      </md-card>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import Pagination from "@/components/Pagination";
import Swal from "sweetalert2";

export default {
  components: {
    // pagination: Pagination,
  },

  data: () => ({
    table: [],
    footerTable: [
      "Name",
      "Category",
      "Picture",
      "Tags",
      "Created At",
      "Actions",
    ],

    query: null,

    sortation: {
      field: "created_at",
      order: "asc",
    },

    pagination: {
      perPage: 5,
      currentPage: 1,
      perPageOptions: [5, 10, 25, 50],
    },

    total: 0,
  }),

  computed: {
    sort() {
      if (this.sortation.order === "desc") {
        return `-${this.sortation.field}`;
      }

      return this.sortation.field;
    },

    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },

  watch: {
    query: {
      handler: "getListDebounced",
      immediate: true,
    },
    sortation: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
    pagination: {
      handler: "getList",
      immediate: false,
      deep: true,
    },
  },

  methods: {
    getListDebounced: _.debounce(function () {
      this.getList();
    }, 300),

    getList() {
      let params = {
        include: "category,tags",
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
          ...(this.query ? { name: this.query } : {}),
          ...(this.query ? { category: this.query } : {}),
          ...(this.query ? { tags: this.query } : {}),
        },
        page: {
          number: this.pagination.currentPage,
          size: this.pagination.perPage,
        },
      };

      this.$store.dispatch("packages/list", params).then(() => {
        this.table = this.$store.getters["packages/list"];
        this.total = this.$store.getters["packages/listTotal"];
      });
    },

    async destroy(id) {
      if (this.$isDemo == 1 && ["1", "2"].includes(id)) {
        await this.$store.dispatch(
          "alerts/error",
          "You are not allowed to change data of default items."
        );
        return;
      }
      const confirmation = await Swal.fire({
        title: "Delete this item?",
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, keep it",
        confirmButtonClass: "md-button md-success",
        cancelButtonClass: "md-button md-danger",
      });

      if (confirmation.value === true) {
        try {
          await this.$store.dispatch("items/destroy", id);
          await this.$store.dispatch(
            "alerts/success",
            "Item deleted successfully."
          );
          await this.getList();
        } catch (e) {
          if (e.response.data.errors[0]) {
            await this.$store.dispatch(
              "alerts/error",
              e.response.data.errors[0].title
            );
          } else {
            await this.$store.dispatch(
              "alerts/error",
              "Oops, something went wrong!"
            );
          }
        }
      }
    },

    goToAdd() {
      this.$router.push({ name: "Add Item" });
    },

    goToEdit(id) {
      this.$router.push({ name: "Edit Item", params: { id } });
    },

    customSort() {
      return false;
    },
  },
};
</script>
